export const SIGN_IN_MODAL = 'sign-in';
export const SIGN_UP_MODAL = 'sign-up';
export const SIGN_UP_POPUP = 'sign-up-popup';
export const RESTORE_PASSWORD_MODAL = 'restore-password';
export const CONTACT_US_MODAL = 'contact-us';
/** @deprecated please use SIGN_UP_MODAL key instead. @see SIGN_UP_MODAL  */
export const WAR_ROOM_SIGN_UP_MODAL = 'sign-up';
export const WAR_ROOM_ANNOUNCEMENT_MODAL = 'war-room-announcement';
export const PUBLIC_PORTFOLIO_HEADLINE_MODAL = 'portfolio-headline';
export const PUBLIC_PORTFOLIO_AWARDS_MODAL = 'portfolio-awards';
export const PUBLIC_PORTFOLIO_WORK_HISTORY_MODAL = 'portfolio-work-history';
export const PUBLIC_PORTFOLIO_ADD_WORK_HISTORY_MODAL = 'portfolio-add-work-history';
export const PUBLIC_PORTFOLIO_EDIT_WORK_HISTORY_MODAL = 'portfolio-edit-work-history';
export const PUBLIC_PORTFOLIO_ADD_CLIENTS_MODAL = 'portfolio-add-clients';
export const PUBLIC_PORTFOLIO_CLIENTS_MODAL = 'portfolio-clients';
export const PUBLIC_PORTFOLIO_SETTINGS_MODAL = 'portfolio-settings';
export const PUBLIC_PORTFOLIO_LINKEDIN_IMPORT_MODAL = 'portfolio-import';
export const PUBLIC_PORTFOLIO_LINKEDIN_ERROR_MODAL = 'portfolio-import-error';
export const PUBLIC_PORTFOLIO_PRIVACY_MODAL = 'portfolio-privacy';
export const WAR_ROOM_USERNAME_AVATAR_MODAL = 'username-avatar';
export const PUBLIC_PORTFOLIO_TESTIMONIAL_MODAL = 'portfolio-testimonial';
export const PUBLIC_PORTFOLIO_REQUEST_TESTIMONIAL_MODAL = 'portfolio-request-testimonial';
export const PUBLIC_PORTFOLIO_REQUEST_TESTIMONIAL_SUCCESS_MODAL = 'portfolio-request-testimonial-success';
export const PUBLIC_PORTFOLIO_EDIT_TESTIMONIALS_MODAL = 'portfolio-edit-testimonials';
export const PUBLIC_PORTFOLIO_APPROVE_TESTIMONIAL_SUCCESS_MODAL = 'portfolio-approve-testimonial-success';
export const PUBLIC_PORTFOLIO_CONNECTIONS_IMPORT_MODAL = 'portfolio-connections-import';
export const PUBLIC_PORTFOLIO_CONNECTIONS_SUCCESS_MODAL = 'portfolio-connections-success';
export const PUBLIC_PORTFOLIO_CONNECT_MODAL = 'portfolio-connect';
export const PUBLIC_PORTFOLIO_APPROVE_TESTIMONIAL_MODAL = 'portfolio-approve-testimonial';
export const PUBLIC_PORTFOLIO_SCREENSHOT_TESTIMONIAL_MODAL = 'portfolio-screenshot-testimonial';
export const PORTFOLIO_EDIT_PERSONAL_INFO_MODAL = 'portfolio-edit-personal-info';
export const CONFIRM_NEW_DEAL_MODAL = 'confirm-new-deal';
export const GONG_ANIMATION_MODAL = 'gong-animation-modal';
export const EMPLOYER_ONBOARDING_MODAL = 'employer-onboarding-modal';
export const DIRECT_MESSAGES_PROMO_MODAL = 'direct-messages-promo';
export const PORTFOLIO_SHARE_MODAL = 'portfolio-share';
export const PORTFOLIO_SALES_EXPERIENCE_MODAL = 'portfolio-sales-experience';
export const PUBLIC_PORTFOLIO_EDUCATION_MODAL = 'portfolio-education';
export const PUBLIC_PORTFOLIO_EDUCATION_SECTION_MODAL = 'portfolio-education-section';
export const REFERRAL_MODAL = 'referral-program';
export const REFERRAL_HIRED_MODAL = 'referral-hired';
export const REFERRAL_JOBS_MODAL = 'referral-program-jobs';
export const OPTIONAL_ANONYMITY_LEARN_MORE_MODAL = 'optional-anonymity-learn-more-modal';
export const JOBS_MY_MATCHES_INTERVIEW_DATE_MODAL = 'jobs-my-matches-interview-date-modal';
export const JOBS_MY_MATCHES_EMAIL_INTRODUCTION_MODAL = 'jobs-my-matches-email-introduction-modal';
